import React from "react";
import { createStyles, Fab, withStyles, WithStyles } from "@material-ui/core";
import { get } from "lodash";
import { useDispatch, useSelector } from "react-redux";

import colors from "../../../../../../theme/colors";
import { openDialog } from "../../../../../../modules/ui";
import { getFactorClient } from "../../../../../../modules/factoringClient";
import {
  enabledReportCount,
  REPORT_VISIBILITY_DIALOG_VARIANT,
  REPORT_VISIBILITY_TYPES
} from "../dialogs/reportVisibilityTypes";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const styles = () =>
  createStyles({
    button: {
      boxShadow:
        "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
      background: colors.purple,
      color: colors.white,
      textTransform: "none"
    }
  });

export default withStyles(styles)(
  ({ classes }: WithStyles<typeof styles>): JSX.Element => {
    const dispatch = useDispatch();
    const factoring: any = useSelector(getFactorClient);
    const reportVisibility: Record<string, boolean> = get(
      factoring,
      "report_visibility",
      {}
    );
    const enabled = enabledReportCount(reportVisibility);
    return (
      <Fab
        variant="extended"
        size="medium"
        className={classes.button}
        onClick={(): void => {
          dispatch(openDialog(REPORT_VISIBILITY_DIALOG_VARIANT));
        }}
      >
        {`Report Visibility ${enabled} / ${REPORT_VISIBILITY_TYPES.length}`}
      </Fab>
    );
  }
);
